var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1876 49.5837L46.6667 33.1045L42.4376 28.8753L30.1147 41.1982L23.9897 35.0732L19.8334 39.2295L30.1876 49.5837ZM18.9584 58.3337C14.5348 58.3337 10.7558 56.8024 7.62133 53.7399C4.48494 50.6774 2.91675 46.9344 2.91675 42.5107C2.91675 38.7191 4.05911 35.3406 6.34383 32.3753C8.62855 29.41 11.6181 27.5142 15.3126 26.6878C16.5279 22.2156 18.9584 18.5941 22.6042 15.8232C26.2501 13.0524 30.382 11.667 35.0001 11.667C40.6876 11.667 45.5117 13.6474 49.4726 17.6082C53.4354 21.571 55.4167 26.3962 55.4167 32.0837C58.7709 32.4725 61.5544 33.9182 63.7672 36.4207C65.978 38.9252 67.0834 41.8545 67.0834 45.2087C67.0834 48.8545 65.8079 51.9539 63.2567 54.507C60.7037 57.0581 57.6042 58.3337 53.9584 58.3337H18.9584Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudRight);
export default __webpack_public_path__ + "static/media/cloud_right.ee928e71af7f4a68b57ef754beee5357.svg";
export { ForwardRef as ReactComponent };